import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import DateTime from '../../../../../../components/library/common/DateTime'

const DoxExplorerFilesTableModifiedCell = (props) => {
    return (
        <div className={classnames('doxe-files-table-cell hrb-column modified', `hrb-is-${props.width}`)}
            style={{ justifyContent: props.justifyContent }}>
            <DateTime value={props.modifiedTs} fallbackValue='-' dateAndTime compact />
        </div>
    )
}

DoxExplorerFilesTableModifiedCell.propTypes = {    
    modifiedTs: PropTypes.string.isRequired,    
    width: PropTypes.number.isRequired,
    justifyContent: PropTypes.string
}   

export default DoxExplorerFilesTableModifiedCell;